import {MenuItem} from '../models/menu.model';
import {EmployeeModulesEnum} from "../../../modules/app/employees/enums/employee-modules.enum";

// menu items for vertcal and detached layout
// label values are translation keys resolved via the `translate` pipe in left-sidebar.component.html
const MENU_ITEMS: MenuItem[] = [

    {
        key: 'dashboard',
        label: 'SIDEBAR.DASHBOARD',
        isTitle: false,
        icon: 'home',
        module: EmployeeModulesEnum.ORDER,
        link: '/apps/dashboard',
    },
    { key: 'restaurant', label: 'SIDEBAR.SECTION_RESTAURANT', isTitle: true },
    {
        key: 'restaurant-orders-main',
        label: 'SIDEBAR.ORDERS',
        isTitle: false,
        icon: 'check-square',
        link: '/apps/restaurant/orders',
        children: [
            {
                key: 'restaurant-orders',
                label: 'SIDEBAR.ORDERS_LIST',
                link: '/apps/restaurant/orders/list',
                parentKey: 'restaurant-orders-main',
                module: EmployeeModulesEnum.ORDER,
            },
            {
                key: 'restaurant-tables-orders',
                label: 'SIDEBAR.TABLE_RESERVATIONS',
                link: '/apps/restaurant/table-reservations/list',
                parentKey: 'restaurant-orders-main',
                module: EmployeeModulesEnum.TABLE_RESERVATION,
            }
        ]
    },
    {
        key: 'restaurant-menu-main',
        label: 'SIDEBAR.MENU',
        isTitle: false,
        icon: 'book',
        link: '/apps/restaurant/menu/details',
        module: EmployeeModulesEnum.MENU,
    },
    {
        key: 'restaurant-food-package',
        label: 'SIDEBAR.FOOD_PACKAGES',
        isTitle: false,
        icon: 'shopping-bag',
        link: '/apps/restaurant/food-packages',
        module: EmployeeModulesEnum.FOOD_PACKAGES,
        children: [
            {
                label: 'SIDEBAR.FOOD_PACKAGES_AVAILABLE',
                link: '/apps/restaurant/food-packages',
                parentKey: 'restaurant-food-package',
            },
            {
                label: 'SIDEBAR.FOOD_PACKAGES_ORDERS',
                link: '/apps/restaurant/food-packages/orders',
                parentKey: 'restaurant-food-package',
            },
        ]
    },
    {
        key: 'restaurant-stock-main',
        label: 'SIDEBAR.WAREHOUSE',
        isTitle: false,
        icon: 'layers',
        module: EmployeeModulesEnum.INVENTORY,
        link: '/apps/restaurant/stocks',
        children: [
            {
                label: 'SIDEBAR.WAREHOUSE_LIST',
                link: '/apps/restaurant/stocks',
                parentKey: 'restaurant-stock-main',
            },
            {
                label: 'SIDEBAR.WAREHOUSE_PRODUCTS',
                link: '/apps/restaurant/stocks/products',
                parentKey: 'restaurant-stock-main',
            },
            {
                label: 'SIDEBAR.WAREHOUSE_DOCUMENTS',
                link: '/apps/restaurant/stocks/orders',
                parentKey: 'restaurant-stock-orders',
            },
            {
                label: 'SIDEBAR.WAREHOUSE_PRODUCTION',
                link: '/apps/restaurant/stocks/production',
                parentKey: 'restaurant-stock-production',
            },
            {
                label: 'SIDEBAR.WAREHOUSE_CONTACTS',
                link: '/apps/restaurant/stocks/contacts',
                parentKey: 'restaurant-stock-orders',
            },
            {
                label: 'SIDEBAR.WAREHOUSE_MOVEMENTS',
                link: '/apps/restaurant/stocks/inventory-movements',
                parentKey: 'restaurant-stock-orders',
            },
            {
                label: 'SIDEBAR.WAREHOUSE_INVENTORIES',
                link: '/apps/restaurant/stocks/inventories',
                parentKey: 'restaurant-stock-orders',
            },
            {
                label: 'SIDEBAR.WAREHOUSE_WASTE',
                link: '/apps/restaurant/stocks/waste-report',
                parentKey: 'restaurant-stock-orders',
            },
            {
                label: 'SIDEBAR.WAREHOUSE_ALERTS',
                link: '/apps/restaurant/stocks/alert-settings',
                parentKey: 'restaurant-stock-orders',
            },
            {
                label: 'SIDEBAR.WAREHOUSE_FOODCOST',
                link: '/apps/restaurant/stocks/foodcost',
                parentKey: 'restaurant-stock-main',
                module: EmployeeModulesEnum.INVENTORY,
            },
        ]
    },
    {
        label: 'SIDEBAR.RESTAURANT_SETTINGS',
        isTitle: false,
        icon: 'settings',
        link: '/apps/restaurant/settings',
        key: 'restaurant-settings',
        module: EmployeeModulesEnum.RESTAURANT_MANAGEMENT,
        children: [
            {
                label: 'SIDEBAR.RESTAURANT_SETTINGS_LOCATIONS',
                link: '/apps/restaurant/settings/restaurants',
                parentKey: 'restaurant-settings',
            },
            {
                label: 'SIDEBAR.RESTAURANT_SETTINGS_ABOUT',
                link: '/apps/restaurant/settings/about',
                parentKey: 'restaurant-settings',
            },
            {
                label: 'SIDEBAR.RESTAURANT_SETTINGS_WORKING_HOURS',
                link: '/apps/restaurant/settings/working-hours',
                parentKey: 'restaurant-settings',
            },
            {
                label: 'SIDEBAR.RESTAURANT_SETTINGS_DELIVERY_ZONES',
                link: '/apps/restaurant/settings/delivery-zones',
                parentKey: 'restaurant-settings',
            },
            {
                label: 'SIDEBAR.RESTAURANT_SETTINGS_DELIVERY',
                link: '/apps/restaurant/settings/delivery',
                parentKey: 'restaurant-settings',
            },
            {
                label: 'SIDEBAR.RESTAURANT_SETTINGS_TABLES',
                link: '/apps/restaurant/settings/tables',
                parentKey: 'restaurant-settings',
            },

        ]
    },
    {
        key: 'restaurant-stats-main',
        label: 'SIDEBAR.STATS',
        isTitle: false,
        icon: 'bar-chart-2',
        link: '/apps/restaurant/statistics',
        children: [
            {
                key: 'restaurant-stats-reports',
                label: 'SIDEBAR.STATS_REPORTS',
                link: '/apps/restaurant/statistics/reports',
                parentKey: 'restaurant-stats-main',
                module: EmployeeModulesEnum.ORDER,
                children: [
                    {
                        key: 'restaurant-stats-reports-finance',
                        label: 'SIDEBAR.STATS_REPORTS_FINANCE',
                        link: '/apps/restaurant/statistics/reports/finance',
                        parentKey: 'restaurant-stats-reports',
                        module: EmployeeModulesEnum.ORDER,
                    },
                    {
                        key: 'restaurant-stats-reports-sales',
                        label: 'SIDEBAR.STATS_REPORTS_SALES',
                        link: '/apps/restaurant/statistics/reports/sales',
                        parentKey: 'restaurant-stats-reports',
                        module: EmployeeModulesEnum.ORDER,
                    },
                    {
                        key: 'restaurant-stats-reports-delivery',
                        label: 'SIDEBAR.STATS_REPORTS_DELIVERY',
                        link: '/apps/restaurant/statistics/reports/delivery',
                        parentKey: 'restaurant-stats-reports',
                        module: EmployeeModulesEnum.COURIERS,
                    },
                    {
                        key: 'restaurant-stats-reports-employees',
                        label: 'SIDEBAR.STATS_REPORTS_EMPLOYEES',
                        link: '/apps/restaurant/statistics/reports/employees',
                        parentKey: 'restaurant-stats-reports',
                        module: EmployeeModulesEnum.ORDER,
                    },
                    {
                        key: 'restaurant-stats-reports-customers',
                        label: 'SIDEBAR.STATS_REPORTS_CUSTOMERS',
                        link: '/apps/restaurant/statistics/reports/customers',
                        parentKey: 'restaurant-stats-reports',
                        module: EmployeeModulesEnum.ORDER,
                    },
                    {
                        key: 'restaurant-stats-reports-calls',
                        label: 'SIDEBAR.STATS_CALLS',
                        link: '/apps/restaurant/statistics/reports/calls',
                        parentKey: 'restaurant-stats-reports',
                        module: EmployeeModulesEnum.ORDER,
                    },
                    // {
                    //     key: 'restaurant-stats-reports-orders',
                    //     label: 'Zamkniętych rachunków',
                    //     link: '/apps/restaurant/statistics/reports/orders',
                    //     parentKey: 'restaurant-stats-reports',
                    //     module: EmployeeModulesEnum.ORDER,
                    // },
                ]
            },
            {
                key: 'restaurant-stats-invoices',
                label: 'SIDEBAR.STATS_INVOICES',
                link: '/apps/restaurant/statistics/invoices',
                parentKey: 'restaurant-stats-main',
                module: EmployeeModulesEnum.INVOICES,
            },
            {
                key: 'restaurant-stats-orders',
                label: 'SIDEBAR.STATS_ORDERS_HISTORY',
                link: '/apps/restaurant/statistics/orders',
                parentKey: 'restaurant-stats-main',
                module: EmployeeModulesEnum.ORDER,
            },
            {
                key: 'restaurant-clients',
                label: 'SIDEBAR.STATS_CLIENTS',
                link: '/apps/restaurant/statistics/clients',
                parentKey: 'restaurant-stats-main',
                module: EmployeeModulesEnum.CLIENTS,
            },
            {
                key: 'restaurant-review',
                label: 'SIDEBAR.STATS_REVIEWS',
                link: '/apps/restaurant/statistics/reviews',
                parentKey: 'restaurant-stats-main',
                module: EmployeeModulesEnum.REVIEWS,
            },
        ]
    },
    { key: 'mobile', label: 'SIDEBAR.SECTION_GENERAL', isTitle: true },
    {
        key: 'restaurant-marketing-main',
        label: 'SIDEBAR.MARKETING',
        isTitle: false,
        icon: 'inbox',
        link: '/apps/restaurant/marketing',
        children: [
            {
                key: 'restaurant-marketing-promo-codes',
                label: 'SIDEBAR.MARKETING_PROMO_CODES',
                link: '/apps/restaurant/marketing/promo-codes/list',
                parentKey: 'restaurant-marketing-main',
                module: EmployeeModulesEnum.PROMO_CODES,
            },
            {
                key: 'restaurant-marketing-loyalty',
                label: 'SIDEBAR.MARKETING_LOYALTY',
                link: '/apps/restaurant/marketing/loyalty-program',
                parentKey: 'restaurant-marketing-main',
                module: EmployeeModulesEnum.LOYALTY_PROGRAM,
            },
            {
                key: 'restaurant-special-offer-list',
                label: 'SIDEBAR.MARKETING_SPECIAL_OFFERS',
                link: '/apps/restaurant/marketing/special-offers',
                parentKey: 'restaurant-marketing-main',
                module: EmployeeModulesEnum.SPECIAL_OFFER,
            },
            {
                key: 'restaurant-coupons-list',
                label: 'SIDEBAR.MARKETING_COUPONS',
                link: '/apps/restaurant/marketing/coupons',
                parentKey: 'restaurant-marketing-main',
                module: EmployeeModulesEnum.COUPONS,
            },
            {
                key: 'restaurant-cross-selling-list',
                label: 'SIDEBAR.MARKETING_CROSS_SELLING',
                link: '/apps/restaurant/marketing/cross-selling',
                parentKey: 'restaurant-marketing-main',
                module: EmployeeModulesEnum.CROSS_SELLING,
            },
            {
                key: 'restaurant-marketing-campaigns',
                label: 'SIDEBAR.MARKETING_CAMPAIGNS',
                link: '/apps/restaurant/marketing/campaigns',
                parentKey: 'restaurant-marketing-main',
                module: EmployeeModulesEnum.MARKETING_CAMPAIGN,
            },
            {
                key: 'restaurant-marketing-auto-campaigns',
                label: 'SIDEBAR.MARKETING_AUTOMATION',
                link: '/apps/restaurant/marketing/auto-campaigns/list',
                parentKey: 'restaurant-marketing-main',
                module: EmployeeModulesEnum.MARKETING_AUTOMATION,
            }
        ]
    },
    {
        key: 'restaurant-table-order',
        label: 'SIDEBAR.TABLE_ORDER',
        isTitle: false,
        mdiIcon: 'mdi-qrcode',
        module: EmployeeModulesEnum.RESTAURANT_MANAGEMENT,
        link: '/apps/restaurant/table-order',
    },
    {
        key: 'restaurant-qr-menu',
        label: 'SIDEBAR.QR_MENU',
        isTitle: false,
        mdiIcon: 'mdi-qrcode-scan',
        link: '/apps/restaurant/qr-menu',
    },
    {
        key: 'restaurant-kds-app',
        isTitle: false,
        mdiIcon: 'mdi-chef-hat',
        label: 'SIDEBAR.KDS',
        link: '/apps/restaurant/kds-app',
    },
    {
        key: 'restaurant-kiosk',
        isTitle: false,
        mdiIcon: 'mdi-cellphone-settings',
        label: 'SIDEBAR.KIOSK',
        link: '/apps/restaurant/kiosk',
    },
    {
        key: 'restaurant-pos',
        isTitle: false,
        mdiIcon: 'mdi-food',
        label: 'SIDEBAR.POS',
        children: [
            {
                key: 'restaurant-pos-app',
                label: 'SIDEBAR.POS_APP',
                link: '/apps/pos/app',
                parentKey: 'restaurant-pos',
            },
            {
                key: 'restaurant-pos-discount',
                label: 'SIDEBAR.POS_DISCOUNTS',
                link: '/apps/pos/discounts',
                parentKey: 'restaurant-pos',
            },
            {
                label: 'SIDEBAR.POS_KITCHEN_PRINTERS',
                link: '/apps/restaurant/settings/kitchen-printers',
                parentKey: 'restaurant-settings',
            },
        ]
    },
    {
        label: 'SIDEBAR.SETTINGS',
        isTitle: false,
        icon: 'settings',
        link: '/apps/global/settings',
        key: 'global-settings',
        module: EmployeeModulesEnum.SETTINGS,
        children: [
            {
                key: 'global-settings-online-payment',
                label: 'SIDEBAR.SETTINGS_ONLINE_PAYMENT',
                link: '/apps/global/settings/online-payment',
                parentKey: 'global-settings',
            },
            {
                key: 'global-settings-terms',
                label: 'SIDEBAR.SETTINGS_TERMS',
                link: '/apps/global/settings/terms',
                parentKey: 'global-settings',
            },
            {
                key: 'global-settings-settings',
                label: 'SIDEBAR.SETTINGS_GLOBAL',
                link: '/apps/global/settings/settings',
                parentKey: 'global-settings',
            },
        ]
    },
    {
        key: 'employees',
        isTitle: false,
        mdiIcon: 'mdi-account-multiple-outline',
        label: 'SIDEBAR.EMPLOYEES',
        link: '/apps/employees',
        module: EmployeeModulesEnum.EMPLOYEES,
    },
    {
        key: 'erp',
        isTitle: false,
        mdiIcon: 'mdi-calendar-clock',
        label: 'SIDEBAR.ERP',
        link: '/apps/restaurant/erp',
        module: EmployeeModulesEnum.EMPLOYEES,
    },
    {
        key: 'couriers',
        isTitle: false,
        mdiIcon: 'mdi-moped',
        label: 'SIDEBAR.COURIERS',
        link: '/apps/couriers',
        module: EmployeeModulesEnum.COURIERS,
    },
    {
        key: 'integrations',
        isTitle: false,
        mdiIcon: 'mdi-connection',
        label: 'SIDEBAR.INTEGRATIONS',
        link: '/apps/integrations',
        module: EmployeeModulesEnum.INTEGRATIONS,
    },
    {
        key: 'food-integrators',
        isTitle: false,
        mdiIcon: 'mdi-food-fork-drink',
        label: 'SIDEBAR.FOOD_INTEGRATORS',
        link: '/apps/food-integrators',
        module: EmployeeModulesEnum.FOOD_INTEGRATORS,
        children: [
            // {
            //     key: 'food-integrators-list',
            //     label: 'Integracje',
            //     link: '/apps/food-integrators/list',
            //     parentKey: 'food-integrators',
            // },
            {
                key: 'food-integrators-menu',
                label: 'SIDEBAR.FOOD_INTEGRATORS_MENU',
                link: '/apps/food-integrators/menu',
                parentKey: 'food-integrators',
            },
            // {
            //     key: 'food-integrators-hours',
            //     label: 'Godziny pracy',
            //     link: '/apps/food-integrators/working-hours',
            //     parentKey: 'food-integrators',
            // },
        ]
    },
    {
        label: 'SIDEBAR.BILLINGS',
        isTitle: false,
        icon: 'credit-card',
        link: '/apps/global/billings',
        key: 'global-billings',
        module: EmployeeModulesEnum.BILLINGS,
        children: [
            {
                key: 'global-billings-subscription',
                label: 'SIDEBAR.BILLINGS_SUBSCRIPTION',
                link: '/apps/global/billings/subscription',
                parentKey: 'global-billings',
                ownerOnly: true,
            },
            {
                key: 'global-billings-invoices',
                label: 'SIDEBAR.BILLINGS_INVOICES',
                link: '/apps/global/billings/invoices',
                parentKey: 'global-billings',
            },
        ]
    },
    { key: 'mobile', label: 'SIDEBAR.SECTION_MOBILE_APP', isTitle: true },
    {
        key: 'mobile-apps',
        label: 'SIDEBAR.MOBILE_APPS',
        isTitle: false,
        icon: 'smartphone',
        link: '/apps/mobile/apps',
        module: EmployeeModulesEnum.APP_CONFIGURATOR,
    },
    { key: 'web', label: 'SIDEBAR.SECTION_WEBSITE', isTitle: true },
    {
        key: 'web-configurator',
        label: 'SIDEBAR.WEB_CONFIGURATOR',
        isTitle: false,
        icon: 'sliders',
        link: '/apps/web/list',
        module: EmployeeModulesEnum.WEB_CONFIGURATOR,
    },
];

export { MENU_ITEMS };
